/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type SearchOrganizationType =
  (typeof SearchOrganizationType)[keyof typeof SearchOrganizationType];

export const SearchOrganizationType = {
  cases: "cases",
  documents: "documents",
  all: "all",
} as const;
